angular.module('nv.singleStudent').component('studentSnapshotCard', {
  // tslint:disable-next-line:max-line-length
  template: require('./student-snapshot-card.html'),
  bindings: {
    cardTitle: '@',
    cardItems: '<',
  },
});
